import React from "react";
import { createPortal } from "react-dom";
import CloseIcon from "@mui/icons-material/Close";
import { cn } from "~/utils";

const Modal = ({
  open,
  closeModal,
  children,
  className = "",
  dismissible = true,
}) => {
  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      // There could still be other modals open.
      const numberOfModals =
        document.getElementsByClassName("react-modal").length;
      document.body.style.overflow = numberOfModals ? "hidden" : "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const handleOutsideClick = (e) => {
    if (!document.getSelection().toString() && dismissible) {
      closeModal();
    }
  };
  const handleInsideClick = (e) => e.stopPropagation();

  return (
    <>
      {open &&
        createPortal(
          <div
            onClick={handleOutsideClick}
            className="react-modal fixed bottom-0 left-0 right-0 top-0 z-50 grid h-[100vh] w-[100vw] place-items-center bg-black bg-opacity-60 px-6 py-4"
          >
            <div
              onClick={handleInsideClick}
              className={cn(
                "relative h-72 w-[min(400px,100%)] rounded-lg bg-white p-4 shadow-xl",
                className,
              )}
            >
              {children}
              {dismissible && (
                <div
                  onClick={closeModal}
                  className="absolute right-[-10px] top-[-10px] flex h-7 w-7 cursor-pointer rounded-full bg-black text-white"
                >
                  <CloseIcon className="m-auto h-5 w-5" />
                </div>
              )}
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};

export default Modal;
